import React from 'react';

const HistoryDate = ({message,messageTime}) => {
    
    return (
        <div className="historyDateDiv">
        <span className="historyDateText">{message}</span>
        <span className="bg-line"></span>
        </div>
    )
  }

export default HistoryDate



// WEBPACK FOOTER //
// ./src/components/message-components/history-date.component.js